import styled from "styled-components";
import {Flex} from "./flex";
import {FlexCol} from "./flex-col";

export const FlexColVerCenter = styled(FlexCol)`
    flex-direction: column;
    justify-content: center;
`;
